import useInbox from "hooks/useInbox.ts";
import useInboxQueryParams from "hooks/useInboxQueryParams";
import StatusFilter from "../../Reusable/StatusFilter";
import FormFilter from "../../Reusable/FormFilter";

const Filters = () => {
  const { getQueryParam } = useInboxQueryParams();
  const { getSelectedList } = useInbox();

  return (
    <>
      {(!getSelectedList()?.length || getQueryParam("t") === "picker") && (
        <StatusFilter />
      )}
      {!getSelectedList()?.length && getQueryParam("f") === "jform" && (
        <FormFilter />
      )}
    </>
  );
};

export default Filters;
